__turbopack_context__.v({
  "buttonContainer": "PlaceOfPurchase-module-scss-module__GeH01a__buttonContainer",
  "clearButton": "PlaceOfPurchase-module-scss-module__GeH01a__clearButton",
  "collapsed": "PlaceOfPurchase-module-scss-module__GeH01a__collapsed",
  "dropdownButton": "PlaceOfPurchase-module-scss-module__GeH01a__dropdownButton",
  "fade-in": "PlaceOfPurchase-module-scss-module__GeH01a__fade-in",
  "focused": "PlaceOfPurchase-module-scss-module__GeH01a__focused",
  "innerWrapper": "PlaceOfPurchase-module-scss-module__GeH01a__innerWrapper",
  "input": "PlaceOfPurchase-module-scss-module__GeH01a__input",
  "inputWrapper": "PlaceOfPurchase-module-scss-module__GeH01a__inputWrapper",
  "otherOption": "PlaceOfPurchase-module-scss-module__GeH01a__otherOption",
  "readonly": "PlaceOfPurchase-module-scss-module__GeH01a__readonly",
  "root": "PlaceOfPurchase-module-scss-module__GeH01a__root",
  "selected": "PlaceOfPurchase-module-scss-module__GeH01a__selected",
  "sr-only": "PlaceOfPurchase-module-scss-module__GeH01a__sr-only",
  "staggerIn": "PlaceOfPurchase-module-scss-module__GeH01a__staggerIn",
  "store": "PlaceOfPurchase-module-scss-module__GeH01a__store",
  "suggestedStoresContainer": "PlaceOfPurchase-module-scss-module__GeH01a__suggestedStoresContainer",
  "suggestion": "PlaceOfPurchase-module-scss-module__GeH01a__suggestion",
  "suggestions": "PlaceOfPurchase-module-scss-module__GeH01a__suggestions",
  "suggestionsWrapper": "PlaceOfPurchase-module-scss-module__GeH01a__suggestionsWrapper",
  "topSuggestion": "PlaceOfPurchase-module-scss-module__GeH01a__topSuggestion",
});
